// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
.index__exception___OmNBn {
  display: flex;
  align-items: center;
  height: 100%;
}
.index__exception___OmNBn .index__imgBlock___zDuPW {
  flex: 0 0 62.5%;
  width: 62.5%;
  padding-right: 152px;
  zoom: 1;
}
.index__exception___OmNBn .index__imgBlock___zDuPW:before,
.index__exception___OmNBn .index__imgBlock___zDuPW:after {
  content: ' ';
  display: table;
}
.index__exception___OmNBn .index__imgBlock___zDuPW:after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
.index__exception___OmNBn .index__imgEle___VBn65 {
  height: 360px;
  width: 100%;
  max-width: 430px;
  float: right;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
}
.index__exception___OmNBn .index__content___ERn8G {
  flex: auto;
}
.index__exception___OmNBn .index__content___ERn8G h1 {
  color: #434e59;
  font-size: 72px;
  font-weight: 600;
  line-height: 72px;
  margin-bottom: 24px;
}
.index__exception___OmNBn .index__content___ERn8G .index__desc___HzC1r {
  color: rgba(0, 0, 0, 0.45);
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 16px;
}
.index__exception___OmNBn .index__content___ERn8G .index__actions___MA4Cm button:not(:last-child) {
  margin-right: 8px;
}
@media screen and (max-width: 1200px) {
  .index__exception___OmNBn .index__imgBlock___zDuPW {
    padding-right: 88px;
  }
}
@media screen and (max-width: 576px) {
  .index__exception___OmNBn {
    display: block;
    text-align: center;
  }
  .index__exception___OmNBn .index__imgBlock___zDuPW {
    padding-right: 0;
    margin: 0 auto 24px;
  }
}
@media screen and (max-width: 480px) {
  .index__exception___OmNBn .index__imgBlock___zDuPW {
    margin-bottom: -24px;
    overflow: hidden;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"exception": `index__exception___OmNBn`,
	"imgBlock": `index__imgBlock___zDuPW`,
	"imgEle": `index__imgEle___VBn65`,
	"content": `index__content___ERn8G`,
	"desc": `index__desc___HzC1r`,
	"actions": `index__actions___MA4Cm`
};
export default ___CSS_LOADER_EXPORT___;
